export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const SWITCH_APP = "SWITCH_APP";

// all dashboards
export const DASHBOARD = {
    Dashboard_Last_24H:'dashboard_last_24h'
}